import AccordionText from "../Utils/AccordionText"
import Attribute from "./Attribute"
import { CustomVariantItemProps, ProductDetailItemProps, ProductVariantItemProps, PromotionItemProps } from "./constants"
import { useEffect, useRef, useState } from "react";
import Image from 'next/image';
import SizeGuide from "./SizeGuide";
import { useAttributesStore } from "@/stores/useAttributesStore";
import Cookies from "js-cookie";
import { bindVoucher, get_original_price, get_sales_price, send_traffic_record } from "@/lib/Definitions";
import ReactPlayer from 'react-player/youtube';
import Link from "next/link";
import RightSideDialog from "../Utils/RightSideDialog";
import VideoPlayer from "./VideoPlayer";
import { User } from "@/stores/initialState";
import CustomToast from "../Utils/CustomToast";
import { event } from 'nextjs-google-analytics';
import ActionDialog from "../Utils/ActionDialog";


interface ProductDetailWithAttrProps extends ProductDetailItemProps {
  setVariantId: (setVariantId: number) => void;
  setOpen: (open: boolean) => void;
  variant: ProductVariantItemProps | null;
  setVariant: (variant: ProductVariantItemProps | null) => void;
  firstVariant: ProductVariantItemProps | null;
  selectedCustomVariant: CustomVariantItemProps | null;
  setSelectedCustomVariant: (variant: CustomVariantItemProps | null) => void;
  fromName: string;
  setFromName: (value: string) => void;
  toName: string;
  setToName: (value: string) => void;
  toEmail: string;
  setToEmail: (value: string) => void;
  toMobile: string;
  setToMobile: (value: string) => void;
  toMessage: string;
  setToMessage: (value: string) => void;
  pregnancy: string;
  setPregnancy: (value: string) => void;
  duDate: Date | null;
  setDuDate: (value: Date | null) => void;
  childName: string;
  setChildName: (value: string) => void;
  childAge: number | null;
  setChildAge: (value: number | null) => void;
  childGender: string;
  setChildGender: (value: string) => void;
  sharedSalesPrice: number;
  affiliate: string | undefined;
  setClickAttribute: (value: boolean) => void;
  setSelectColor: (color: number) => void;
  userData: User;
}

const Detail = (props: ProductDetailWithAttrProps) => {
  const viewport = Cookies.get('viewport');
  const platform = Cookies.get("platform");
  const device = Cookies.get("device");
  const { attributes, getAttributes } = useAttributesStore();
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [attributesData, setAttributesData] = useState(getAttributes());
  const [videoHeight, setVideoHeight] = useState(0);
  const videoRef = useRef<HTMLDivElement>(null);
  const [promoteOpen, setPromoteOpen] = useState(false);
  const [promoteTitle, setPromoteTitle] = useState<JSX.Element | null>(null);
  const [promoteContent, setPromoteContent] = useState<JSX.Element | null>(null);
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [applyVoucherPrice, setApplyVoucherPrice] = useState<number>(0);
  const [affiliateDiscountPercent, setAffiliateDiscountPercent] = useState<number>(0);
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [userOrderCount, setUserOrderCount] = useState<number>(0);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [marketplace, setMarketplace] = useState<string | null>(null);
  const [marketplaceLink, setMarketplaceLink] = useState<string | null>(null);
  const [showWarning, setShowWarning] = useState(false);
  const prevShowWarning = useRef(showWarning);

  const warningElement: JSX.Element = (
    <div className="text-center font-poppins">
      <p className="text-sm font-semibold text-mooimom">HANYA DI WEBSITE!</p>
      <p className="mt-2 text-xs text-black">Jaminan harga terhemat dan promo eksklusif</p>
    </div>
  )

  useEffect(() => {
    if (videoRef.current !== null) {
      setVideoHeight(videoRef.current.offsetWidth * 0.5625);
    }
  }, [])

  useEffect(() => {
    if (props.userData && props.userData.order_status) {
      setUserOrderCount((props.userData.order_status.completed | 0) + (props.userData.order_status.processing | 0) + (props.userData.order_status.paid | 0) + (props.userData.order_status.cancel_shipping | 0) + (props.userData.order_status.delivered | 0) + (props.userData.order_status.reviewed | 0) + (props.userData.order_status.draft | 0));
    }
  }, [props.userData])

  useEffect(() => {
    if (props.video_list && props.video_list.length > 0) {
      setVideoUrl(props.video_list[0]);
    }
  }, [props.video_list])

  const show_add_to_cart = () => {
    if (props.variant !== null && props.variant !== undefined && props.variant.qty > 0) {
      props.setOpen(true);
    } else {
      props.setVariant(props.firstVariant);
      props.setOpen(true);
    }
  }

  const displaySizeGuide = () => {
    setShowSizeGuide(true);
  }

  const handleShowPromotion = (promo: PromotionItemProps) => {
    let promoteImage = null;

    switch (promo.type) {
      case "discount":
      case "cashback":
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-discount-cashback.png";
        break;

      case "free-shipping":
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-free-shipping.png";
        break;

      case "gift":
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-free-gift.png";
        break;

      default:
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-special.png";
    }

    setPromoteTitle(
      <div className="flex items-center space-x-2 font-poppins">
        <Image
          src={promoteImage}
          alt="promotion icon"
          width={28}
          height={28}
          quality={100}
        />
        <p className="text-sm font-bold text-black">{promo.name}</p>
      </div>
    )

    setPromoteContent(
      <div className="font-poppins">
        <p className="my-4 text-sm text-black">Periode : {promo.start_date} - {promo.end_date}</p>
        <p className="text-base font-bold text-black">SYARAT & KETENTUAN :</p>
        <p className="my-4 text-sm text-black">{promo.description}</p>
        <ul className="pl-5 text-sm text-black list-disc list-outside">
          {promo.free_shipping && (
            <li className="my-4">Dapatkan potongan ongkir senilai {process.env.NEXT_PUBLIC_CURRENCY}{promo.shipping_charge?.toLocaleString()}</li>
          )}
          {promo.gift && (
            <li className="my-4">Dapatkan FREE hadiah berupa {promo.gift.replace(`&apos;`, `'`)} setiap pembelanjaan</li>
          )}
          {promo.minimum_amount && promo.minimum_amount > 0 && (
            <li className="my-4">Promo berlaku setiap pembelanjaan dengan minimal belanja {process.env.NEXT_PUBLIC_CURRENCY}{promo.minimum_amount.toLocaleString()}</li>
          )}
          {promo.membership_level && (
            <li className="my-4">Promo hanya berlaku untuk level tertentu</li>
          )}
          <li className="my-4">Promo hanya berlaku di website MOOIMOM</li>
          {promo.gift && (
            <li className="my-4">Promo berlaku selama persediaan masih ada</li>
          )}
        </ul>
      </div>
    );

    setPromoteOpen(true);
  }

  useEffect(() => {
    setAttributesData(getAttributes());
  }, [getAttributes, attributes])

  useEffect(() => {
    if (props.variant === null || props.variant === undefined) {
      props.setVariantId(0);
    } else {
      props.setVariantId(props.variant.variant_id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.variant])

  useEffect(() => {
    const sales_price = get_sales_price(props, props.variant);

    if (!Array.isArray(sales_price.price) && !sales_price.promotion && (((props.variant === null || props.variant === undefined) && props.compare_price && ((userOrderCount === 0 && props.compare_price.voucher_discount > 0 && sales_price.price - props.compare_price.voucher_discount !== applyVoucherPrice) || (userOrderCount > 0 && props.compare_price.repeat_voucher_discount > 0 && sales_price.price - props.compare_price.repeat_voucher_discount !== applyVoucherPrice))) || (props.variant && props.variant.compare_price && ((props.variant.compare_price.voucher_discount > 0 && sales_price.price - props.variant.compare_price.voucher_discount !== applyVoucherPrice) || (props.variant.compare_price.repeat_voucher_discount > 0 && sales_price.price - props.variant.compare_price.repeat_voucher_discount !== applyVoucherPrice))))) {
      setApplyVoucherPrice(userOrderCount === 0 ? sales_price.price - (props.compare_price?.voucher_discount || props.variant?.compare_price?.voucher_discount || 0) : sales_price.price - (props.compare_price?.repeat_voucher_discount || props.variant?.compare_price?.repeat_voucher_discount || 0));
    } else if (((!props.variant && props.compare_price === null) || (props.variant && props.variant.compare_price === null) || (userOrderCount === 0 && (!props.variant && props.compare_price?.voucher_discount === 0) || (props.variant && props.variant.compare_price?.voucher_discount=== 0)) || (userOrderCount > 0 && (props.variant && props.compare_price?.repeat_voucher_discount === 0) || (props.variant && props.variant.compare_price?.repeat_voucher_discount=== 0))) && applyVoucherPrice !== 0) {
      setApplyVoucherPrice(0);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.variant, props.compare_price, userOrderCount]);

  const bind_voucher = async (): Promise<boolean> => {
    if (userOrderCount === 0 ? props.variant === null || props.variant === undefined ? props.compare_price?.voucher_code : props.variant.compare_price?.voucher_code : props.variant === null || props.variant === undefined ? props.compare_price?.repeat_voucher_code : props.variant.compare_price?.repeat_voucher_code) {
      const data = {
        voucher_code: userOrderCount === 0 ? props.variant === null || props.variant === undefined ? props.compare_price?.voucher_code : props.variant.compare_price?.voucher_code : props.variant === null || props.variant === undefined ? props.compare_price?.repeat_voucher_code : props.variant.compare_price?.repeat_voucher_code,
        platform: device && device === "app" ? platform : "web",
        type: 'bind',
      }

      return bindVoucher('Bearer ' + props.userData.token, data)
        .then((response) => {
          event("click_bind_voucher", {
            event_category: device && device === "app" ? platform : "web",
            event_label: userOrderCount === 0 ? props.variant === null || props.variant === undefined ? props.compare_price?.voucher_code : props.variant.compare_price?.voucher_code : props.variant === null || props.variant === undefined ? props.compare_price?.repeat_voucher_code : props.variant.compare_price?.repeat_voucher_code,
          });
          setMessage("Berhasil! Voucher Dapat Digunakan");
          setOpen(true);
          return true;
        })
        .catch((error) => {
          return false;
        });
    } else {
      return Promise.resolve(false);
    }
  }

  const show_sales_price = () => {
    const sales_price = get_sales_price(props, props.variant);

    if (Array.isArray(sales_price.price)) {
      return (
        <p className={`flex text-xl md:text-2xl text-price font-bold`}>
          {process.env.NEXT_PUBLIC_CURRENCY}{sales_price.price[0].toLocaleString()} ~ {process.env.NEXT_PUBLIC_CURRENCY}{sales_price.price[1].toLocaleString()}
        </p>
      )
    } else {
      return (
        <p className={`flex text-xl md:text-2xl font-bold ${sales_price.promotion ? "text-mooimom" : "text-price"}`}>
          {process.env.NEXT_PUBLIC_CURRENCY}{sales_price.price.toLocaleString()}
        </p>
      )
    }
  }

  const show_origin_price = () => {
    const origin_price = get_original_price(props, props.variant);

    if (origin_price === null) {
      return (<></>)
    } else {
      return (
        <p className="text-base line-through text-originPrice">
          {process.env.NEXT_PUBLIC_CURRENCY}{origin_price.toLocaleString()}
        </p>
      )
    }
  }

  const show_affiliate_origin_price = () => {
    const origin_price = get_original_price(props, props.variant);

    if (origin_price === null) {
      const sales_price = get_sales_price(props, props.variant);

      if (Array.isArray(sales_price.price)) {
        return (
          <p className="text-sm line-through text-originPrice">
            {process.env.NEXT_PUBLIC_CURRENCY}{sales_price.price[1].toLocaleString()}
          </p>
        )
      } else {
        return (
          <p className="text-sm line-through text-originPrice">
            {process.env.NEXT_PUBLIC_CURRENCY}{sales_price.price.toLocaleString()}
          </p>
        )
      }
    } else {
      return (
        <p className="text-sm line-through text-originPrice">
          {process.env.NEXT_PUBLIC_CURRENCY}{origin_price.toLocaleString()}
        </p>
      )
    }
  }

  useEffect(() => {
    const sales_price = get_sales_price(props, props.variant);
    const origin_price = get_original_price(props, props.variant);

    let salesPrice = 0;
    let originPrice = 0;

    if (!Array.isArray(sales_price.price)) {
      salesPrice = sales_price.price;
    }

    if (origin_price !== null) {
      originPrice = origin_price;
    }

    if (originPrice > 0 && salesPrice > 0) {
      setDiscountPercent(Math.round((originPrice - salesPrice) / originPrice * 100));
    } else if (Array.isArray(sales_price.price)) {
      setDiscountPercent(-1);
    } else {
      setDiscountPercent(0);
    }

    if (props.sharedSalesPrice > 0) {
      if (originPrice > 0) {
        setAffiliateDiscountPercent(Math.round((originPrice - props.sharedSalesPrice) / originPrice * 100));
      } else if (salesPrice > 0) {
        setAffiliateDiscountPercent(Math.round((salesPrice - props.sharedSalesPrice) / salesPrice * 100));
      } else if (Array.isArray(sales_price.price)) {
        setAffiliateDiscountPercent(-1);
      } else {
        setAffiliateDiscountPercent(0);
      }
    }
  }, [props, props.variant, props.sharedSalesPrice])

  const generate_how_to_use = () => {
    return props.how_to_use.map((use, index) => {
      if (use.title !== "" && use.description !== "") {
        return (
          <div key={index}>
            <p className="font-bold">{use.title}</p>
            <p className="font-normal">{use.description}</p>
          </div>
        );
      } else if (use.title !== "" && use.document !== "") {
        return (
          <div key={index}>
            <Link href={use.document} className="underline text-mooimom">
              {use.title}
            </Link>
          </div>
        );
      } else if (use.video_link !== "") {
        return (
          <div key={index} className="w-full" ref={videoRef}>
            <ReactPlayer
              url={use.video_link}
              width="100%"
              height={videoHeight}
              playing={false}
              loop={true}
              controls={true}
              muted={true}
            />
          </div>
        );
      } else {
        return (<></>);
      }
    });
  }

  const handle_click_marketplace = () => {
    if (!marketplaceLink || marketplaceLink.length === 0) {
      return;
    }

    send_traffic_record('Bearer ' + props.userData.token, props.userData.uuid, '/product/' + props.slug, 'click_marketplace')
      .then(() => {
        event("click_marketplace", {
          event_category: marketplace,
          event_label: marketplaceLink,
        });

        window.open(marketplaceLink, "_blank");
      });
  }

  useEffect(() => {
    if (prevShowWarning.current && !showWarning) {
      send_traffic_record('Bearer ' + props.userData.token, props.userData.uuid, '/product/' + props.slug, 'close_marketplace_warning')
        .then(() => {
          setShowWarning(false);
          event("close_marketplace_warning", {
            event_category: marketplace,
            event_label: marketplaceLink,
          });
        });
    }
    prevShowWarning.current = showWarning;
  }, [showWarning, marketplace, marketplaceLink, props.slug, props.userData.token, props.userData.uuid]);

  // useEffect 來設定 marketplace 資訊，避免在 render 中設定狀態
  useEffect(() => {
    if (props.variant && props.variant.compare_price && props.variant.compare_price.marketplace.length > 0 && props.variant.compare_price.mp_url) {
      setMarketplace(props.variant.compare_price.marketplace[0]);
      setMarketplaceLink(props.variant.compare_price.mp_url);
    } else if (props.compare_price && props.compare_price.marketplace.length > 0 && props.compare_price.mp_url) {
      setMarketplace(props.compare_price.marketplace[0]);
      setMarketplaceLink(props.compare_price.mp_url);
    } else {
      setMarketplace(null);
      setMarketplaceLink(null);
    }
  }, [props.variant, props.compare_price]);

  const generate_marketplace = () => {
    if (props.variant && props.variant.compare_price && props.variant.compare_price.price > 0) {
      return props.variant.compare_price.marketplace.map((marketplace, index) => {
        if (index === 0 && props.variant?.compare_price?.mp_url) {
          return (
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + `/images/icons/${marketplace}-logo-icon.png`}
              alt={`${marketplace} icon`}
              quality={100}
              width={16}
              height={16}
              key={index}
              onClick={() => setShowWarning(true)}
              className="cursor-pointer"
            />
          )
        } else {
          return (
            <Image
              key={index}
              src={process.env.NEXT_PUBLIC_STATIC_SITE + `/images/icons/${marketplace}-logo-icon.png`}
              alt={`${marketplace} icon`}
              quality={100}
              width={16}
              height={16}
            />
          )
        }
      })
    } else if (props.compare_price) {
      return props.compare_price.marketplace.map((marketplace, index) => {
        if (index === 0 && props.compare_price?.mp_url) {
          return (
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + `/images/icons/${marketplace}-logo-icon.png`}
              alt={`${marketplace} icon`}
              quality={100}
              width={16}
              height={16}
              key={index}
              onClick={() => setShowWarning(true)}
              className="cursor-pointer"
            />
          )
        } else {
          return (
            <Image
              key={index}
              src={process.env.NEXT_PUBLIC_STATIC_SITE + `/images/icons/${marketplace}-logo-icon.png`}
              alt={`${marketplace} icon`}
              quality={100}
              width={16}
              height={16}
            />
          )
        }
      })
    } else {
      return (<></>);
    }
  }

  return (
    <>
      <section className={`mt-6 md:mt-0 font-poppins col-span-1 md:col-span-6`}>
        <div className={viewport === "desktop" ? "" : "container"}>
          <div className="text-xs font-bold text-attributeBorder">{props.brand}</div>
          <hr className="bg-attributeBorder w-[65px] mt-1" />
          <h1 className="mt-4 text-base font-bold text-black capitalize md:text-2xl md:mt-2">{props.name}</h1>
          <div className="hidden mt-2 text-xs md:block text-sku">{props.product_code}</div>
          {props.sharedSalesPrice === 0 && (
            <>
              <div className="flex items-center mt-2 space-x-2 font-bold">
                {discountPercent === 0 && show_sales_price()}
                {show_origin_price()}
              </div>
              {discountPercent === -1 && (
                <div className="flex items-center px-3 py-2 mt-3 space-x-2 border border-solid rounded-lg md:px-4 md:mt-4 border-price flex-nowrap w-fit md:space-x-3">
                  <div className="bg-white min-w-[78px] rounded-l-lg">{show_sales_price()}</div>
                  <p className="text-[8px] font-bold text-cartProductName md:text-sm">Harga Ekslusif Website</p>
                </div>
              )}
              {discountPercent > 0 && (
                <div className="flex items-center px-3 py-2 mt-3 space-x-2 border border-solid rounded-lg md:px-4 md:mt-4 border-price flex-nowrap w-fit md:space-x-3">
                  <div className="bg-white min-w-[78px] rounded-l-lg">{show_sales_price()}</div>
                  <p className="text-[8px] font-bold text-cartProductName md:text-sm">Harga Ekslusif Website</p>
                  <p className="flex items-center justify-center text-xs font-bold text-center text-white rounded-full bg-price md:text-sm w-7 h-7 md:w-9 md:h-9">{discountPercent}%</p>
                </div>
              )}
            </>
          )}
          {props.sharedSalesPrice > 0 && (
            <>
              <div className="flex items-center mt-2 space-x-2 font-bold">
                <p className={`flex text-xl text-affiliatePrice`}>
                  {process.env.NEXT_PUBLIC_CURRENCY}{props.sharedSalesPrice.toLocaleString()}
                </p>
                {show_affiliate_origin_price()}
              </div>
              {affiliateDiscountPercent === -1 && (
                <div className="flex items-center mt-2 border border-solid border-affiliatePrice flex-nowrap w-fit">
                  <div className="p-2 text-xs font-bold bg-white">
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/package-green.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                  <div className="flex items-center p-2 space-x-2 bg-affiliatePrice">
                    <p className="text-xs font-medium text-white">Harga Spesial afiliasi</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/discount-white.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              )}
              {affiliateDiscountPercent > 0 && (
                <div className="flex items-center mt-2 border border-solid border-affiliatePrice flex-nowrap w-fit">
                  <p className="text-xs font-bold bg-white text-affiliatePrice py-2 px-4 min-w-[78px]">{affiliateDiscountPercent}% Off</p>
                  <div className="flex items-center p-2 space-x-2 bg-affiliatePrice">
                    <p className="text-xs font-medium text-white">Harga Spesial afiliasi</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/discount-white.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {applyVoucherPrice > 0 && (
            <>
              <div className="flex items-center px-3 py-2 mt-4 space-x-2 border border-solid rounded-lg md:px-4 w-fit bg-price md:mt-7 border-price flex-nowrap">
                <p className="text-xl font-bold text-white md:text-2xl">{process.env.NEXT_PUBLIC_CURRENCY}{applyVoucherPrice.toLocaleString()}</p>
                <div
                  className="flex items-center justify-center cursor-pointer"
                  onClick={bind_voucher}
                >
                  <div className="flex items-center justify-center">
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/voucher-yellow-icon.png"}
                      alt="voucher discount icon"
                      width={36}
                      height={80}
                      quality={100}
                      className="w-auto h-6 md:h-8"
                    />
                    <p className="h-6 md:h-8 bg-voucherDiscountBg text-center text-white font-bold flex items-center justify-center text-[10px] md:text-[15px] leading-normal pr-[6px] md:pr-2">-{process.env.NEXT_PUBLIC_CURRENCY}{userOrderCount === 0 ? props.variant === null || props.variant === undefined ? props.compare_price?.voucher_discount.toLocaleString() : props.variant.compare_price?.voucher_discount.toLocaleString() : props.variant === null || props.variant === undefined ? props.compare_price?.repeat_voucher_discount.toLocaleString() : props.variant?.compare_price?.repeat_voucher_discount.toLocaleString()}</p>
                  </div>
                  <div className="flex items-center justify-center">
                    <p className="h-6 md:h-8 bg-white text-center text-voucherBindingText font-bold flex items-center justify-center text-[10px] md:text-[15px] leading-normal underline pl-2">Klaim Voucher</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/voucher-white-icon.png"}
                      alt="voucher discount icon"
                      width={36}
                      height={80}
                      quality={100}
                      className="w-auto h-6 md:h-8"
                    />
                  </div>
                </div>
              </div>
              {((userOrderCount === 0 && (((props.variant === null || props.variant === undefined) && props.compare_price && props.compare_price.voucher_desc !== null && props.compare_price.voucher_desc.length > 0) || (props.variant && props.variant.compare_price && props.variant.compare_price.voucher_desc !== null && props.variant.compare_price.voucher_desc.length > 0))) || (userOrderCount > 0 && (((props.variant === null || props.variant === undefined) && props.compare_price && props.compare_price.repeat_voucher_desc !== null && props.compare_price.repeat_voucher_desc.length > 0) || (props.variant && props.variant.compare_price && props.variant.compare_price.repeat_voucher_desc !== null && props.variant.compare_price.repeat_voucher_desc.length > 0)))) && (
                <p className="mt-2 text-[8px] md:text-xs md:mt-3 text-price" dangerouslySetInnerHTML={{__html: userOrderCount === 0 ? props.compare_price?.voucher_desc || props.variant?.compare_price?.voucher_desc || "" : props.compare_price?.repeat_voucher_desc || props.variant?.compare_price?.repeat_voucher_desc || ""}}></p>
              )}
            </>
          )}
          {(((props.variant === null || props.variant === undefined) && props.compare_price && props.compare_price.price > 0) || (props.variant && props.variant.compare_price !== null && props.variant.compare_price !== undefined && props.variant.compare_price.price > 0)) && (
            <div className="flex items-center mt-4 bg-white border border-solid rounded-lg md:mt-7 border-attributeBorder flex-nowrap w-fit">
              <div className="py-2 px-4 text-center text-base md:text-xl font-bold text-attributeBorder min-w-[78px] rounded-l-lg">
                {process.env.NEXT_PUBLIC_CURRENCY}{props.variant && props.variant.compare_price && props.variant.compare_price.price > 0 ? props.variant.compare_price.price.toLocaleString() : props.compare_price?.price.toLocaleString()}
              </div>
              <div className="flex items-center px-4 py-2 space-x-4 border-l rounded-r-lg border-attributeBorder">
                {generate_marketplace()}
              </div>
            </div>
          )}
        </div>
        {props.selling_points.length > 0 && (
          <>
            <hr className="my-6 bg-reviewBg" />
            <div className={viewport === "desktop" ? "" : "container"}>
              <ul className="pl-5 text-sm font-normal leading-8 text-black list-disc list-outside font-poppins">
                {props.selling_points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </>
        )}
        {props.attribute_value_list.length > 0 && (<hr className="my-6 bg-reviewBg" />)}
        <div className={viewport === "desktop" ? "" : "container"}>
          <Attribute
            product_code={props.product_code}
            attribute_value_list={props.attribute_value_list}
            product_variant_list={props.product_variant_list}
            attributes={attributesData.data}
            style="normal"
            variant={props.variant}
            setVariant={props.setVariant}
            virtual_product={props.virtual_product}
            need_shipping={props.need_shipping}
            custom_variant_list={props.custom_variant_list}
            selectedCustomVariant={props.selectedCustomVariant}
            setSelectedCustomVariant={props.setSelectedCustomVariant}
            fromName={props.fromName}
            setFromName={props.setFromName}
            toName={props.toName}
            setToName={props.setToName}
            toEmail={props.toEmail}
            setToEmail={props.setToEmail}
            toMobile={props.toMobile}
            setToMobile={props.setToMobile}
            toMessage={props.toMessage}
            setToMessage={props.setToMessage}
            pregnancy={props.pregnancy}
            setPregnancy={props.setPregnancy}
            duDate={props.duDate}
            setDuDate={props.setDuDate}
            childName={props.childName}
            setChildName={props.setChildName}
            childAge={props.childAge}
            setChildAge={props.setChildAge}
            childGender={props.childGender}
            setChildGender={props.setChildGender}
            setClickAttribute={props.setClickAttribute}
            setSelectProductColor={props.setSelectColor}
            use_product_option={props.use_product_option}
          />
        </div>
        {props.variant !== null && props.variant !== undefined && props.variant.qty === 0 && (
          <div className={`my-4 text-base italic leading-9 text-promotionPrice ${viewport === "desktop" ? "" : "container"}`}>Stok produk tidak tersedia</div>
        )}
        {((props.size_guide.category !== null && props.size_guide.category !== undefined) ||
          (props.size_guide.image !== null && props.size_guide.image !== undefined) ||
          (props.size_guide.measure !== null && props.size_guide.measure !== undefined) ||
          (props.size_guide.suggestion !== null && props.size_guide.suggestion !== undefined)) && (
          <div className={viewport === "desktop" ? "" : "container"}>
            <button
              className="flex p-2 mt-6 shadow-md bg-sizeGuideBg"
              onClick={displaySizeGuide}
            >
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/size-guide.png"}
                alt="size guide icon"
                width={20}
                height={20}
                quality={100}
              />
              <p className="ml-2 text-sm text-black">Size Guide</p>
            </button>
          </div>
        )}
        <div
          className={`md:hidden z-10 fixed bottom-10 left-1/2 -translate-x-1/2 py-2 px-4 w-[200px] rounded-lg text-white text-sm font-poppins font-medium shadow-xl flex justify-center items-center space-x-2 ${props.variant !== null && props.variant !== undefined && props.variant.qty === 0 ? "bg-disabledBtn" : "bg-review cursor-pointer"}`}
          onClick={show_add_to_cart}
        >
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/cart-white.png"}
            alt="tambahkan ke keranjang"
            quality={100}
            width={20}
            height={20}
          />
          <p>Add To Cart</p>
        </div>
        <hr className="my-6 bg-reviewBg" />
        {props.promotion && props.promotion.length > 0 && (
          <div className={`${viewport === "desktop" ? "" : "container"}`}>
            <p className="mb-4 text-sm font-bold text-black">Promotions</p>
            <div className="ml-4 space-y-3">
            {props.promotion.map((promo, index) => (
              <div key={index}>
                <div
                  className="flex items-center w-full space-x-2 cursor-pointer"
                  onClick={() => handleShowPromotion(promo)}
                >
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + `/images/icons/${promo.type === "free-shipping" ? "free-shipping" : "gift"}.png`}
                    alt="promotion icon"
                    quality={100}
                    width={24}
                    height={24}
                    className="flex-none"
                  />
                  <p className="text-xs font-semibold text-black grow">{promo.name}</p>
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/more-detail.png"}
                    alt="more detail icon"
                    quality={100}
                    width={20}
                    height={20}
                    className="flex-none md:hidden"
                  />
                  <p className="flex-none hidden text-xs text-black underline md:block">lihat detail</p>
                </div>
              </div>
            ))}
            </div>
          </div>
        )}
        <div className={`${viewport === "desktop" ? "" : "container"} ${process.env.NEXT_PUBLIC_STYLE_OPTION === "A" ? "" : "md:hidden"}`}>
          {props.promotion && props.promotion.length > 0 && (<hr className="my-6 bg-reviewBg" />)}
          {props.description_list.map((desc, index) => (
            <div key={index}>
              {desc.title === "" ? (
                <AccordionText
                  title="Deskripsi"
                  title_style="text-black text-sm font-bold leading-8"
                  description={desc.description}
                  desc_style="font-normal text-sm text-black leading-8"
                  border={false}
                />
              ) : (
                <AccordionText
                  title={desc.title}
                  title_style="text-black text-sm font-bold leading-8"
                  description={desc.description}
                  desc_style="font-normal text-sm text-black leading-8"
                  border={true}
                />
              )}
            </div>
          ))}
          {props.how_to_use.length > 0 && (
            <AccordionText
              title="Instruksi Manual"
              title_style="text-black text-sm font-bold leading-8"
              description=""
              descriptionElement={generate_how_to_use()}
              desc_style="font-normal text-sm text-black leading-8"
              border={true}
            />
          )}
        </div>
        <SizeGuide
          size_guide={props.size_guide}
          isVisible={showSizeGuide}
          setIsVisible={setShowSizeGuide}
        />
      </section>
      <div className="hidden col-span-2 md:block border border-reviewBg rounded sticky py-4 px-3 top-[120px] h-fit">
        <button
          className={`w-full h-fit flex items-center justify-center space-x-2 py-1 px-2 text-white text-sm font-poppins font-normal rounded ${props.variant !== null && props.variant !== undefined && props.variant.qty === 0 ? "bg-disabledBtn" : "bg-review"}`}
          onClick={show_add_to_cart}
        >
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/cart-white.png"}
            alt="tambahkan ke keranjang"
            quality={100}
            width={16}
            height={16}
          />
          <p>Add To Cart</p>
        </button>
      </div>
      <RightSideDialog isVisible={promoteOpen} setIsVisible={setPromoteOpen} title={promoteTitle} content={promoteContent} />
      {videoUrl !== "" && (
        <VideoPlayer videoUrl={videoUrl} setVideoUrl={setVideoUrl} viewport={viewport} page_title={props.meta.title} page_path={`/product/${props.slug}`} />
      )}
      <CustomToast open={open} setOpen={setOpen} message={message} />
      <ActionDialog
        open={showWarning}
        setOpen={setShowWarning}
        message=""
        messageElement={warningElement}
        action={handle_click_marketplace}
        bgColor="bg-white"
        confirmBgColor="bg-mooimom"
        confirmTextColor="text-white"
        confirmText="Keluar"
        cancelBgColor="bg-white"
        cancelTextColor="text-attributeBorder border border-attributeBorder border-solid"
        cancelText="Tetap di Website"
      />
    </>
  )
}

export default Detail
